<main class="home" [attr.aria-busy]="homeBlocksLoading() ? 'true' : null">

  <app-hero [heroData]="heroData()" />

  @if (homeBlocksLoading()) {
    <section class="home-skeleton home-skeleton--categories" aria-label="Cargando categorías">
      <div class="home-skeleton__inner">
        <app-categories-carousel-block [categories]="[]" [loading]="true" />
      </div>
    </section>

    @for (row of homeSkeletonRows; track row) {
      <section
        class="home-skeleton home-skeleton--products"
        [class.home-skeleton--alt]="row % 2 === 0"
        aria-label="Cargando productos del home"
      >
        <div class="home-skeleton__inner">
          <header class="home-skeleton__header">
            <span class="home-skeleton__line home-skeleton__line--title"></span>
            <span class="home-skeleton__line home-skeleton__line--button"></span>
          </header>

          <div class="home-skeleton__tabs" aria-hidden="true">
            @for (tab of homeSkeletonTabs; track tab) {
              <span class="home-skeleton__line home-skeleton__line--tab"></span>
            }
          </div>

          <div class="home-skeleton__product-grid">
            @for (slot of homeSkeletonProducts; track slot) {
              <div class="home-skeleton__product" aria-hidden="true">
                <span class="home-skeleton__media"></span>
                <span class="home-skeleton__line home-skeleton__line--name"></span>
                <span class="home-skeleton__line home-skeleton__line--meta"></span>
                <span class="home-skeleton__line home-skeleton__line--price"></span>
              </div>
            }
          </div>
        </div>
      </section>
    }

    <section class="home-skeleton home-skeleton--editorial" aria-label="Cargando contenido editorial">
      <div class="home-skeleton__inner home-skeleton__editorial-grid">
        <span class="home-skeleton__editorial-media" aria-hidden="true"></span>
        <div class="home-skeleton__editorial-copy" aria-hidden="true">
          <span class="home-skeleton__line home-skeleton__line--eyebrow"></span>
          <span class="home-skeleton__line home-skeleton__line--heading"></span>
          <span class="home-skeleton__line home-skeleton__line--body"></span>
          <span class="home-skeleton__line home-skeleton__line--body-short"></span>
        </div>
      </div>
    </section>
  } @else {
    @for (item of renderItems(); track item.kind + '-' + $index) {
    @switch (item.kind) {

      @case ('categories-carousel') {
        <app-categories-carousel-block
          aos="fade-up"
          [categories]="$any(item).data"
          [loading]="false"
        />
      }

      @case ('offers') {
        <app-offers-block
          aos="fade-up"
          [aosDelay]="100"
          [data]="$any(item).data"
          (zoomOpen)="onZoomOpen($event)"
          (addToCart)="onAddToCart($event)"
          (reserveClick)="onReserve($event)"
          (notifyRequest)="onNotify($event)"
          (notifyCancel)="onNotifyCancel($event)"
          (cardClick)="onCardClick($event)"
        />
      }

      @case ('subcategories-carousel') {
        <app-perron-singles-block
          aos="fade-up"
          [aosDelay]="100"
          [data]="$any(item).data"
          (zoomOpen)="onZoomOpen($event)"
          (addToCart)="onAddToCart($event)"
          (reserveClick)="onReserve($event)"
          (notifyRequest)="onNotify($event)"
          (notifyCancel)="onNotifyCancel($event)"
          (cardClick)="onCardClick($event)"
        />
      }

      @case ('new-arrivals') {
        <app-new-releases-block
          aos="fade-up"
          [aosDelay]="100"
          [data]="$any(item).data"
          (zoomOpen)="onZoomOpen($event)"
          (addToCart)="onAddToCart($event)"
          (reserveClick)="onReserve($event)"
          (notifyRequest)="onNotify($event)"
          (notifyCancel)="onNotifyCancel($event)"
          (cardClick)="onCardClick($event)"
        />
      }

      @case ('best-sellers') {
        <app-top-sellers-block
          aos="fade-up"
          [data]="$any(item).data"
          (zoomOpen)="onZoomOpen($event)"
          (addToCart)="onAddToCart($event)"
          (reserveClick)="onReserve($event)"
          (notifyRequest)="onNotify($event)"
          (notifyCancel)="onNotifyCancel($event)"
          (cardClick)="onCardClick($event)"
        />
      }

      @case ('featured-categories-pair') {
        <app-featured-categories-block aos="fade-up" [data]="$any(item).data" />
      }

      @case ('featured-category') {
        <app-featured-category-block
          aos="fade-up"
          [data]="$any(item).data"
          (zoomOpen)="onZoomOpen($event)"
          (addToCart)="onAddToCart($event)"
          (reserveClick)="onReserve($event)"
          (notifyRequest)="onNotify($event)"
          (notifyCancel)="onNotifyCancel($event)"
          (cardClick)="onCardClick($event)"
        />
      }

      @case ('featured-product') {
        <app-featured-product-block
          aos="zoom-in"
          [product]="$any(item).data"
          (zoomOpen)="onZoomOpen($event)"
          (addToCart)="onAddToCart($event)"
          (reserveClick)="onReserve($event)"
          (notifyRequest)="onNotify($event)"
        />
      }

      @case ('hero-banner') {
        <app-hero-banner-block aos="fade-up" [data]="$any(item).data" />
      }

      @case ('stats-banner') {
        <app-stats-block aos="fade-up" [data]="$any(item).data" />
      }

      @case ('community') {
        <!-- Los eventos van en llamada aparte (D2), nunca dentro del payload
             cacheado de /web/home. Cuelga del slot de comunidad para heredar su
             posición sin pedir nada al backoffice, y queda fuera de
             `comunidad-block` porque ese bloque lo reutiliza /nosotros. -->
        <app-eventos-block aos="fade-up" />
        <app-comunidad-block aos="fade-up" [data]="$any(item).data" />
      }

    }
    }
  }

  @if (zoomProduct(); as product) {
    <app-product-zoom-modal
      [product]="product"
      [notifyActive]="zoomNotifyActive()"
      (close)="onZoomClose()"
      (viewDetails)="onViewDetails($event)"
      (addToCart)="onZoomAddToCart($event)"
      (reserveRequest)="onZoomReserve($event)"
      (notifyRequest)="onNotify($event)"
      (notifyCancel)="onNotifyCancel($event)"
    />
  }

</main>
